export default "__VITE_ASSET__DZlh2qoH__"